import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { AppState } from '@app/store/state/app.state';
import { WhereaboutsGroupType } from '@features/whereabouts/models/movements.models';
import {
  selectFocusedGroupId,
  selectFocusedUserId,
} from '@features/whereabouts/store/editMovements.duck';
import EditMovementsPanel
  from '@shared/ui/organisms/movements-wallchart/components/edit-movements-panel/EditMovementsPanel';

interface Props {
  userId: string;
}

// Mounts the whereabouts edit panel under a wall-planner user row when that
// user is being edited (week-scope editing started from a WeekCell).
export function WallPlannerEditWeekRow({ userId }: Props) {
  const isEditing = useSelector((state: AppState) =>
    selectFocusedUserId(state) === userId && selectFocusedGroupId(state) === WhereaboutsGroupType.Users);

  if (!isEditing) return null;

  return (
    <StickyPanelWrapper>
      <EditMovementsPanel isEditing={isEditing} userId={userId} />
    </StickyPanelWrapper>
  );
}

// The planner grid content is wider than its overflow-x container; sticky-left
// keeps the panel inside the visible viewport at any horizontal scroll offset.
const StickyPanelWrapper = styled.div`
  position: sticky;
  left: 0;
  max-width: 100%;
  z-index: 1001;
  background: white;
`;
